import { InspectionReportProgress } from 'app/modules/inspection/types';

const getValueFromField = (field) => {
  const { name, value, defaultValue, items, fields } = field;
  if (items && Array.isArray(items)) {
    return {
      [name]: items.map((item) => {
        const parseValueFromFields = item.reduce((acc, itemField) => {
          return { ...acc, ...getValueFromField(itemField) };
        }, {});
        return parseValueFromFields;
      })
    };
  }
  if (
    ['sellingUnitContent', 'innerPackContent', 'outerCartonContent'].includes(
      name
    )
  ) {
    return {
      [name]: fields.reduce((acc, field) => {
        return { ...acc, ...getValueFromField(field) };
      }, {})
    };
  }
  return {
    [name]: value || defaultValue
  };
};

export const consolidateCriteria =
  (progress: InspectionReportProgress) => (criteria) => {
    const { fields } = criteria;
    const parseValueFromFields = fields.reduce((acc, field) => {
      return { ...acc, ...getValueFromField(field) };
    }, {});
    return {
      name: criteria.name,
      label: criteria.value,
      progress: progress.sectionProgress[criteria.name],
      result: progress.sectionResults[criteria.name],
      fields: criteria.fields,
      value: parseValueFromFields
    };
  };
